import { render, staticRenderFns } from "./collectBook.vue?vue&type=template&id=55bff13c&scoped=true&"
import script from "./collectBook.vue?vue&type=script&lang=js&"
export * from "./collectBook.vue?vue&type=script&lang=js&"
import style0 from "./collectBook.vue?vue&type=style&index=0&lang=css&"
import style1 from "./collectBook.vue?vue&type=style&index=1&id=55bff13c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bff13c",
  null
  
)

export default component.exports